export default "__VITE_ASSET__CZbDFgHQ__"